import type {
  DestinationFormValue,
  DestinationTranslationValue,
} from '@/shared/api/types/destination-types'

export type DestinationDraftFormValue = DestinationFormValue

export type DestinationDraftTranslationValue = DestinationTranslationValue

export interface PersistedDestinationDraft {
  form: DestinationDraftFormValue
  translations: DestinationDraftTranslationValue[]
}

export interface BuildDestinationDraftInput {
  form: DestinationDraftFormValue
  translations: DestinationDraftTranslationValue[]
}

export function buildDestinationDraft(
  input: BuildDestinationDraftInput,
): PersistedDestinationDraft {
  return {
    form: input.form,
    translations: input.translations,
  }
}

export function hasDestinationDraftContent(
  input: BuildDestinationDraftInput,
  defaultForm: DestinationDraftFormValue,
): boolean {
  const formChanged = JSON.stringify(input.form) !== JSON.stringify(defaultForm)
  const hasTranslationContent = input.translations.some(
    (row) => (row.title ?? '').trim() || (row.name ?? '').trim() || (row.description ?? '').trim(),
  )
  return formChanged || hasTranslationContent
}
